// extracted by mini-css-extract-plugin
export var cartContainer = "_ji-4";
export var gray = "_ji-1";
export var itemContainer = "_ji-2";
export var itemDetails = "_ji-3";
export var strong = "_ji-0";